import React, { Component } from "react";
import { PaymentTransaction } from "../../actions/index";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { ToastContainer, toast, Flip } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { toastConfig } from "../Custom/ToastConfig";
import { capitalize } from "./../Custom/Capitalize";
import Payment from "../Landing/Payment";
import moment from "moment";
const FA = require("react-fontawesome");

export class PickServiceDeatails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.userDetail.name ? props.userDetail.name : null,
      phone: props.userDetail.phoneNumber,
      status: "Session Booked",
      position: "",
      show: false,
      error: "",
      paymentDetail: null,
      showPayment: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    let self = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        self.setState({
          position: position.coords.latitude + "," + position.coords.longitude,
        });
      });
    }
  }

  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleClick = async (e) => {
    e.preventDefault();
    console.log("User Details for booking", this.props);
    const { user } = this.props;

    // DEBUG: Log the original trial_date
    console.log("🔴 ORIGINAL trial_date:", user.trial_date);
    console.log("🔴 Type of trial_date:", typeof user.trial_date);

    let validTrainingNeededFor = (user.training_needed_for || "").toLowerCase();
    if (
      validTrainingNeededFor !== "self" &&
      validTrainingNeededFor !== "other"
    ) {
      validTrainingNeededFor = "self";
    }

    // FIXED: Proper ISO 8601 date formatting
    let trialDateISO = "";
    if (user.trial_date) {
      const dateStr = user.trial_date.toString().trim();
      console.log("🟡 Raw date string:", dateStr);

      // Remove any extra spaces and normalize
      const normalizedDate = dateStr.replace(/\s+/g, "").replace(/--/g, "-");
      console.log("🟡 Normalized date:", normalizedDate);

      if (normalizedDate.includes("-")) {
        const parts = normalizedDate.split("-");
        console.log("🟡 Date parts:", parts);

        if (parts.length === 3) {
          // Check which format we have
          if (parts[0].length === 2 && parts[1].length === 4) {
            // Handle "MM-YYYY-DD" format (like "10-2025-11")
            const [month, year, day] = parts;
            trialDateISO = `${year}-${month.padStart(2, "0")}-${day.padStart(
              2,
              "0"
            )}`;
          } else if (parts[0].length === 2 && parts[2].length === 4) {
            // Handle "MM-DD-YYYY" format
            const [month, day, year] = parts;
            trialDateISO = `${year}-${month.padStart(2, "0")}-${day.padStart(
              2,
              "0"
            )}`;
          } else if (parts[0].length === 4) {
            // Already "YYYY-MM-DD" format
            trialDateISO = normalizedDate;
          }
        }
      }

      // Final validation - if still not valid, use today's date as fallback
      if (!trialDateISO || !/^\d{4}-\d{2}-\d{2}$/.test(trialDateISO)) {
        console.log("🟡 Fallback to current date");
        const today = new Date();
        trialDateISO = today.toISOString().split("T")[0];
      }
    }

    console.log("🟢 FINAL trial_date (ISO):", trialDateISO);

    let formattedData = {
      service_booking_step: 1,
      service_type: user.typeOfservice ? user.typeOfservice.toLowerCase() : "",
      preferred_time_to_be_served: user.service_time,
      training_for: user.user_category ? user.user_category.toLowerCase() : "",
      trial_date: trialDateISO,
      trial_time: user.trial_time,
      trainer_type: user.trainer_category
        ? user.trainer_category.toLowerCase()
        : "",
      training_needed_for: validTrainingNeededFor,
      booking_name:
        user.typeOfservice === "YOGA"
          ? "Morning Yoga Session"
          : "Personal Training",
      address: user.address,
      area: user.area,
      landmark: user.landmark,
      pincode: user.pincode,
    };

    console.log("🚀 FINAL PAYLOAD:", JSON.stringify(formattedData, null, 2));

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        "https://d1dgpoid6t01jm.cloudfront.net/user/createOrUpdateBooking",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(formattedData),
        }
      );

      const data = await response.json();
      console.log("📩 API Response:", data);

      if (response.ok && data && data.response) {
        this.props.nextStep(data.response.paymentResponse);
      } else {
        toast.error(
          (data && data.message) || "Booking failed. Please try again.",
          toastConfig
        );
      }
    } catch (error) {
      toast.error("Error: " + (error.message || "Network error"), toastConfig);
    }
  };

  render() {
    return (
      <div>
        {/* Limited Time Offer Banner */}
        <div
          style={{
            background: "linear-gradient(135deg, #ff6b6b, #ff8e53)",
            color: "white",
            padding: "15px 20px",
            borderRadius: "8px",
            marginBottom: "20px",
            textAlign: "center",
            boxShadow: "0 4px 15px rgba(255, 107, 107, 0.3)",
            border: "2px solid #fb505fff",
            animation: "pulse 2s infinite",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              fontFamily: "Arial, Helvetica, sans-serif",
            }}
          >
            ⚡ Limited Time Offer!
          </div>
          <div
            style={{
              fontSize: "14px",
              opacity: 0.9,
              fontFamily: "Arial, Helvetica, sans-serif",
            }}
          >
            Book your trial session for just{" "}
            <span
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              ₹99 (Refundable)
            </span>{" "}
            before the offer ends.
          </div>
          <div
            style={{
              fontSize: "12px",
              opacity: 0.7,
              marginTop: "5px",
              fontFamily: "Arial, Helvetica, sans-serif",
            }}
          >
            T&C apply
          </div>
        </div>

        <style>
          {`
            @keyframes pulse {
              0% { transform: scale(1); }
              50% { transform: scale(1.02); }
              100% { transform: scale(1); }
            }
          `}
        </style>

        <div className="container-row-service justify_content">
          <table className="table">
            <tbody>
              <tr>
                <td>Service </td>
                <td>
                  {this.props.service ? capitalize(this.props.service) : null}
                </td>
              </tr>
              <tr>
                <th>Service Package</th>
                <td>
                  {this.props.user.trainer_category
                    ? this.props.user.trainer_category
                    : null}
                </td>
              </tr>
              <tr>
                <th>SubTotal</th>
                <td className="packageamount">
                  &#8377;
                  {this.props.user.bookamount || null}
                </td>
              </tr>
              {/* Debug row - show the trial date */}
              <tr>
                <th>Selected Trial Date</th>
                <td>{this.props.user.trial_date || "Not selected"}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="iconContainerRow proceed_to_pay">
          <FA name="arrow-left" onClick={this.back} className="iconPrev" />
          <button
            type="submit"
            className="proceed button-slanted"
            onClick={this.handleClick}
          >
            Proceed to pay
          </button>
        </div>
        <ToastContainer
          transition={Flip}
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

const mapStateToProps = (State) => {
  return {
    user: State.bookSession,
    userDetail: State.userDetail.userlogindetails,
    service: State.serviceState.services,
  };
};

export default withRouter(connect(mapStateToProps, null)(PickServiceDeatails));
